import { render, staticRenderFns } from "./SoundSelector.vue?vue&type=template&id=06394c70&"
import script from "./SoundSelector.vue?vue&type=script&lang=js&"
export * from "./SoundSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoundSelector.vue"
export default component.exports